import './BdaApplicationDetail.scss';
import 'react-js-cron/dist/styles.css'

import { Helmet } from "react-helmet";
import { solid, regular } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Alert, Badge, Card, Col, Container, Row, ListGroup, ListGroupItem, Modal, Button, Form, Breadcrumb, Table, Offcanvas, Collapse } from 'react-bootstrap';
import { useParams } from 'react-router';
import { Applications } from '../../api/Applications';
import AlidaLoader from '../../components/common/AlidaLoader';
import DesignerComponent from '../../components/designer/Designer';
import UserItem from '../../components/common/UserItem';
import { useToasts } from '../../contexts/toasts';
import { fixProcedure, formatDate, getStatusBadge, getExecutionTime, renderTopicLink, getStringType, SMART_UPDATE_EXAMPLE_PAYLOAD } from '../../utils';
import classNames from 'classnames';
import IconButton from '../../components/common/IconButton';
import { useFullScreenLoader } from '../../contexts/fullScreenLoader';
import { useNavigate } from 'react-router';
import { K8sClient } from '../../api/K8sClient';
import FileSaver from 'file-saver';
import { Link } from 'react-router-dom';
import { QueryDetails, VizClient } from '../../api/VizClient';
import { Models } from '../../api/Models';
import { GraphV2, getIdFromUUID, isGraphEdge, translateGraph } from '../../utils/DesignerUtils';
import { Schedules } from '../../api/Schedules';
import { cloneDeep, set } from 'lodash';
import { Cron } from 'react-js-cron';
import { isAfter, isBefore } from 'date-fns';
import { Collapse as AntCollapse, Flex, Select, Tag, Tooltip, Button as AntButton, Dropdown } from 'antd';
import { EventEmitter } from '../../utils/EventEmitter';
import { ApplicationVersion, BdaApplication } from '../../models/BdaApplication';
import { BdaDataset } from '../../models/BdaDataset';
import { BdaService, AssetsPropertyValue, BdaServiceApplicationProperty } from '../../models/BdaService';
import { BdaModel } from '../../models/BdaModel';
import { Execution, Schedule } from '../../models/Workflow';
import { AppNotification } from '../../models/Notification';
import { AssetFile, ExecutionStatus, Option } from '../../models/generics';
import AssetFileItem from '../../components/list-items/AssetFileItem';
import { ReactFlowProvider, useReactFlow } from 'reactflow';
import AssetProjectsEditor from '../../components/forms/AssetProjectsEditor';
import ScriptEditor from '../../components/common/ScriptEditor';
import { FileSearchOutlined } from "@ant-design/icons";
import { editor } from 'monaco-editor';
import { useAuth } from '../../contexts/auth';
import { useSelector } from 'react-redux';
import { sectionLabelsSelector } from '../../slices/sectionsSlice';
import { RootState } from '../../store';
import AnnotationsForm from '../../components/forms/AnnotationsForm';
import AppTag from '../../components/common/AppTag';
import { Services } from '../../api/Services';
import MDEditor from '@uiw/react-md-editor';
import AppLoader from '../../components/common/AppLoader';
import EntityDefinitionModal from '../../components/generics/EntityDefinitionModal';

const groupsIcons = {
  workflow: solid('project-diagram'),
  datasets: solid('database'),
  models: solid('graduation-cap'),
  schedules: solid('stopwatch'),
}

function BdaApplicationDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [initialGraph, setInitialGraph] = useState<GraphV2>();
  const { setNodes, setEdges } = useReactFlow();

  const { showToast } = useToasts();
  const { showLoader, hideLoader } = useFullScreenLoader();

  const [application, setApplication] = useState<BdaApplication>();
  const [applicationClone, setApplicationClone] = useState<BdaApplication>();
  // const [currentGraph, setCurrentGraph] = useState(null);

  // TODO improve logs and preview
  const [logs, setLogs] = useState<any>();
  const [preview, setPreview] = useState<any[]>();
  const [previewDataset, setPreviewDataset] = useState<BdaDataset>();
  const [logsError, setLogsError] = useState(false);
  const [error, setError] = useState(false);
  const [showElementDetail, setShowElementDetail] = useState(false);
  const [service, setService] = useState<BdaService>();
  const [dataset, setDataset] = useState<BdaDataset>();
  const [model, setModel] = useState<BdaModel>();
  const [runs, setRuns] = useState<Execution[]>();
  const [assetFiles, setAssetFiles] = useState<AssetFile[]>();
  const [selectedRun, setSelectedRun] = useState<Execution>();
  // const [exportOptions, setExportOptions] = useState(new ExportOptions(id));
  const [executionsOptions, setExecutionsOptions] = useState<Option[]>([]);
  const [selectedExecution, setSelectedExecution] = useState<string | undefined>();
  const [selectedAsset, setSelectedAsset] = useState<string>();
  const [exportMode, setExportMode] = useState('cluster');
  const [showSmartUpdateExample, setShowSmartUpdateExample] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showVersions, setShowVersions] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showAssetsModal, setShowAssetsModal] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showDeleteScheduleModal, setShowDeleteScheduleModal] = useState(false);
  const [showEnvVarsModal, setShowEnvVarsModal] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [showServiceNotesModal, setShowServiceNotesModal] = useState(false);
  const [showCloneModal, setShowCloneModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [newSchedule, setNewSchedule] = useState(new Schedule());
  const [schedule, setSchedule] = useState<Schedule>();
  const [customCron, setCustomCron] = useState<string>();
  const [cronError, setCronError] = useState<string>();
  const [serviceMarkdown, setServiceMarkdown] = useState<string>();
  const [markdownError, setMarkdownError] = useState(false);
  const [showProjectsModal, setShowProjectsModal] = useState(false);
  const [showRunModal, setShowRunModal] = useState(false);
  const [selectedNamespace, setSelectedNamespace] = useState<string>("alida");
  const [selectedEnvironmentVariables, setSelectedEnvironmentVariables] = useState<Record<string, string>>();
  const [showEditServicePropertiesModal, setShowEditServicePropertiesModal] = useState(false);
  const [serviceProperties, setServiceProperties] = useState<string>();
  const [applicationNamespaces, setApplicationNamespaces] = useState<string[]>();
  const [invalidProperties, setInvalidProperties] = useState(false);
  const [showDeploymentSuggestionsModal, setShowDeploymentSuggestionsModal] = useState(false);
  const [deploymentSuggestions, setDeploymentSuggestions] = useState<string[]>();
  const [showLogsModal, setShowLogsModal] = useState(false);
  const [showDocumentationModal, setShowDocumentationModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewError, setPreviewError] = useState(false);

  const { loggedUser } = useAuth();

  const modelLabels = useSelector((state: RootState) => sectionLabelsSelector(state, "models"));
  const serviceLabels = useSelector((state: RootState) => sectionLabelsSelector(state, "services"));
  const applicationLabels = useSelector((state: RootState) => sectionLabelsSelector(state, "applications"));
  const datasetLabels = useSelector((state: RootState) => sectionLabelsSelector(state, "datasets"));
  const datasourceLabels = useSelector((state: RootState) => sectionLabelsSelector(state, "datasources"));
  const environmentVariablesLabels = useSelector((state: RootState) => sectionLabelsSelector(state, "environment-variables"));
  const projectLabels = useSelector((state: RootState) => sectionLabelsSelector(state, "projects"));

  const serviceIsExposable = useMemo(() => {
    const propertyKeys = service?.properties.map(prop => prop.key);
    return propertyKeys?.includes(window.__env.SERVICE_PORTS_TO_EXPOSE_KEY || 'portsToExpose');
  }, [service]);

  const logsButtonDisabled = useMemo(() => {
    if (service) {
      return !service.statusModel || service.statusModel.status === ExecutionStatus.READY || service.statusModel.status === ExecutionStatus.STARTING;
    }
  }, [service]);

  const showRetryButton = useMemo(() => {
    if (service) {
      return (service.statusModel?.status === ExecutionStatus.COMPLETED || service.statusModel?.status === ExecutionStatus.ERROR)
        && (application?.status !== ExecutionStatus.RUNNING && application?.status !== ExecutionStatus.STARTING && application?.status !== ExecutionStatus.STOPPING && application?.status !== ExecutionStatus.READY);
    }
  }, [service, application]);

  const showDownloadAssets = useMemo(() => {
    if (service) {
      const assetsProp = service.properties.find(property => property.key === 'assets');
      const outputs = assetsProp?.value ? JSON.parse(assetsProp.value).outputs as any[] : undefined;
      const deleteOutputs = service.properties.find(property => property.key === 'SYSTEM_DELETE_OUTPUT_ASSETS');
      return assetsProp && outputs?.length && !deleteOutputs?.value && service.statusModel && service.statusModel.status === ExecutionStatus.COMPLETED;
    }
  }, [service]);

  const showActions = useMemo(() => !application?.template || application?.owner?.id === loggedUser?.sub, [application, loggedUser]);

  const serviceExternalUrl = useMemo(() => `${window.__env.EXPOSED_SERVICES_URL}/${id}/${service?.id}/`, [id, service]);
  const serviceInternalUrl = useMemo(() => `bda-${id}-${service?.id}:80`, [id, service]);

  useEffect(() => {
    setApplication(undefined);
    getApplication();
    getNamespaces();
    // eslint-disable-next-line
  }, [id]);

  // TODO improve statusmessage type
  const onStatusNotification = useCallback((statusMessage: any) => {
    if (!statusMessage.serviceId) {
      setApplication(app => ({
        ...app!,
        status: statusMessage.bda.status,
      }));
      // if (currentApplication.status == "STARTED" || currentApplication.status == "RUNNING" || currentApplication.status == "STARTING") buttonsDisabled = true;
      // if (currentApplication.status != "STARTED" && currentApplication.status != "RUNNING") buttonsDisabled = false;
      if (statusMessage.bda.status === "ERROR" || statusMessage.bda.status === "COMPLETED") getApplication();
      if (statusMessage.k8sRunId && statusMessage.initTime && !runs?.find(run => run.k8sRunId === statusMessage.k8sRunId)) {
        setRuns(curr => {
          const newRuns = cloneDeep(curr);
          newRuns?.unshift({
            id: statusMessage.id,
            assetFiles: [],
            currentStatus: statusMessage.status,
            k8sRunId: statusMessage.k8sRunId,
            runType: "manual",
            startDate: statusMessage.initTime,
            dateOfLastStatus: statusMessage.currentUpdate,
            scheduleId: 0,
            servicesStatus: [],
            namespace: statusMessage.namespace,
          });
          return newRuns;
        });
        setExecutionsOptions(curr => {
          const newOptions = cloneDeep(curr);
          newOptions.unshift({ label: formatDate(statusMessage.initTime), value: statusMessage.k8sRunId })
          return newOptions;
        });
      }
    }
    else {
      const serviceRef = application!.workflows[0].services.find(el => el.id === statusMessage.serviceId)?.ref;
      if (!serviceRef) return;

      const newWorkflow = cloneDeep(application!.workflows[0]);
      let serviceIndex = newWorkflow.procedure.findIndex(el => el.id === serviceRef);

      if (serviceIndex < 0) return;
      if (!newWorkflow.procedure[serviceIndex].data.statusModel) newWorkflow.procedure[serviceIndex].data.statusModel = {};
      newWorkflow.procedure[serviceIndex].data.statusModel.status = statusMessage.status;

      serviceIndex = newWorkflow.services.findIndex(el => el.ref === serviceRef);
      if (serviceIndex >= 0) {
        newWorkflow.services[serviceIndex].statusModel!.message = statusMessage.message;
        newWorkflow.services[serviceIndex].statusModel!.status = statusMessage.status;
        if (service) setService({ ...newWorkflow.services[serviceIndex] });
      }
      setApplication(app => ({
        ...app!,
        workflows: [newWorkflow],
      }));
      const graph = translateGraph(newWorkflow.procedure);
      setNodes(graph.nodes);
      setEdges(graph.edges);
    }
    // eslint-disable-next-line
  }, [application, runs]);

  // TODO improve asset type
  const retrieveNewAssetFile = useCallback((asset: any) => {
    const body = { path: asset.path, type: asset.messageType };

    Applications.getApplicationAssetFilesByDetails(+id!, body)
      .then(
        ({ data }) => {
          setAssetFiles(currentNotifications => {
            const newNotifications = cloneDeep(currentNotifications!);
            newNotifications.unshift({ ...asset, ...data });
            return newNotifications;
          });
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('app-asset-error', message, `Asset Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }, [id, showToast]);

  useEffect(() => {
    if (assetFiles) {
      EventEmitter.subscribe(['BDA_APP_ASSET_CREATED', 'BDA_APP_STATUS_CHANGE'], (newNotification: AppNotification) => {
        if (+newNotification.details.bdaId === +id!) {
          if (newNotification.type === "BDA_APP_STATUS_CHANGE") onStatusNotification(newNotification.details);
          else if (newNotification.details.executionId === selectedExecution) {
            if (newNotification.details.messageType !== "log") retrieveNewAssetFile(newNotification.details);
            else {
              setAssetFiles(currentNotifications => {
                const newNotifications = cloneDeep(currentNotifications!);
                newNotifications.unshift(newNotification.details);
                return newNotifications;
              });
            }
          }
        }
      });
      return () => EventEmitter.unsubscribe(['BDA_APP_ASSET_CREATED', 'BDA_APP_STATUS_CHANGE']);
    }
  }, [assetFiles, id, selectedExecution, onStatusNotification, retrieveNewAssetFile]);

  useEffect(() => {
    if (selectedExecution) {
      setAssetFiles(undefined);
      initAssetFiles();
    }
    // eslint-disable-next-line
  }, [selectedExecution]);

  const getAssetFileService = useCallback((assetFile: AssetFile) => {
    return application?.workflows[0].services.find(s => s.id === +assetFile.serviceId);
  }, [application]);

  const getNamespaces = () => {
    Applications.getNamespaces()
      .then(
        ({ data }) => setApplicationNamespaces(data),
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('app-namespaces-error', message, `Namespaces Error ${status ? `(${status})` : ''}`, 'danger');
        },
      )
  }

  const getApplication = useCallback(() => {
    Applications.getApplication(+id!)
      .then(
        ({ data: app }) => {
          const procedure = cloneDeep(app.workflows[0].procedure);
          const fixedGraph = procedure.map(node => {
            if (node.type === "batch" || node.type === "stream") {
              node.data.label = node.data.label || node.data.name || node.data.text;
              node.data.name = node.data.name || node.data.text;
            }
            return node;
          });
          app.workflows[0].procedure = fixProcedure(fixedGraph, app.workflows[0].services);
          setApplication(app);
          const graph = translateGraph(app.workflows[0].procedure, true);
          setInitialGraph(graph);
          setNodes(graph.nodes);
          setEdges(graph.edges);
          setExecutionsOptions(app.workflows[0].runs?.sort((a, b) => isBefore(new Date(a.startDate), new Date(b.startDate)) ? 1 : -1).map(run => ({ label: run.startDate ? formatDate(run.startDate) : "", value: run.k8sRunId })) || []);
          setSelectedExecution(app.workflows[0].runs?.[0]?.k8sRunId);
          setRuns(app.workflows[0].runs);
          if (!app.workflows[0].runs || app.workflows[0].runs.length === 0) setAssetFiles([]);
        },
        (err) => {
          setError(true);
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('application-error', message, `${applicationLabels.singular} Error ${status ? `(${status})` : ''}`, 'danger');
        }
      );
  }, [applicationLabels, id, setEdges, setNodes, showToast]);

  const initAssetFiles = () => {
    Applications.getApplicationAssetFiles(+id!, selectedExecution!)
      .then(
        ({ data }) => setAssetFiles(data),
        (err) => {
          setAssetFiles([]);
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('app-notifications-error', message, `Notifications Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const reload = useCallback(() => {
    setService(undefined);
    setDataset(undefined);
    setModel(undefined);
    setRuns(undefined);
    setApplication(undefined);
    getApplication();
  }, [getApplication]);

  const showApplicationRuns = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.stopPropagation();
    handleElementDetail({ type: "runs" });
  }
  const handleVersionsClose = () => setShowVersions(false);
  const handleNotificationsClose = () => setShowNotifications(false);
  const onShowVersions = () => setShowVersions(true);
  const onShowNotifications = () => setShowNotifications(true);

  // TODO improve element type
  const handleElementDetail = (element: any) => {
    if (isGraphEdge(element)) return;
    setDataset(undefined);
    setService(undefined);
    setModel(undefined);
    setRuns(undefined);

    if (element.type === 'batch' || element.type === 'service' || element.type === 'agent' || element.type === 'mcp') {
      const service = application!.workflows[0].services.find(s => s.ref === element.id);
      if (!service) {
        setShowElementDetail(false);
        return;
      }
      setService(service);
    }
    else if (element.type === 'dataset') {
      const dataset = application!.datasets!.find(d => d.id === element.data.dataset.id);
      if (!dataset) {
        setShowElementDetail(false);
        return;
      }
      setDataset(dataset);
    }
    else if (element.type === "model") {
      const model = application!.models!.find(m => m.id === getIdFromUUID(element.id));
      if (!model) {
        setShowElementDetail(false);
        return;
      }
      setModel(model);
    }
    else if (element.type === "runs") {
      setRuns(application!.workflows![0].runs!);
    }
    setShowElementDetail(true);
  }

  const closeElementDetail = () => {
    setService(undefined);
    setModel(undefined);
    setDataset(undefined);
    setRuns(undefined);
    setShowElementDetail(false);
  }

  const changeAppVersion = (version: ApplicationVersion) => () => navigate(`/bda-applications/${version.bdaId}`, { replace: true });
  const navigateToApplicationEdit = (fromTemplate?: boolean) => () => navigate(`/bda-applications/${application!.id!}/edit${fromTemplate ? '?fromTemplate=true' : ''}`);

  const onDeleteApplication = () => setShowDeleteModal(true);
  const onExportApplication = () => setShowExportModal(true);

  const onDownloadReport = useCallback(() => {
    showLoader();
    Applications.getWorkflowReport(+id!)
      .then(
        ({ data }) => {
          hideLoader();
          const fileContent = new Blob([data], { type: 'application/zip' });
          showToast('download-report-success', `${applicationLabels.singular} report ready to download.`, 'Report Success', 'success');
          FileSaver.saveAs(fileContent, `${application!.name} Report.zip`);
        },
        (err) => {
          hideLoader();
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('download-report-error', message, `Report Error ${status ? `(${status})` : ''}`, 'danger');
        }
      );
  }, [id, showLoader, hideLoader, showToast, applicationLabels, application]);

  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setShowDeleteScheduleModal(false);
  }
  const handleExportClose = () => setShowExportModal(false);
  const handleScheduleClose = () => {
    setShowScheduleModal(false);
    setNewSchedule(new Schedule());
    setValidated(false);
  }
  const openScheduleModal = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.stopPropagation();
    setShowScheduleModal(true);
  }
  const handleExportModeChange = (evt: React.ChangeEvent<HTMLSelectElement>) => setExportMode(evt.target.value);

  // const handleExportOptionsChange = (field: keyof ExportOptions) => (evt: React.ChangeEvent<HTMLInputElement>) => {
  //   const value = evt.target.checked || evt.target.value;
  //   setExportOptions({
  //     ...exportOptions,
  //     [field]: value,
  //   });
  // }

  const handleScheduleFieldChange = (field: keyof Schedule, pure?: boolean) => (evt: any) => {
    const value = pure ? evt : evt.target.value;
    setNewSchedule({
      ...newSchedule,
      [field]: value,
    });
    if (field === "cronExpression") setCustomCron(evt);
  }
  const handleScheduleEdit = (index: number) => () => {
    const schedule = { ...application!.workflows[0].schedules![index] };
    setNewSchedule(schedule);
    setShowScheduleModal(true);
  }
  const openDeleteScheduleModal = (schedule: Schedule) => () => {
    setSchedule(schedule);
    setShowDeleteScheduleModal(true);
  }

  const handleCloneModalClose = () => setShowCloneModal(false);

  const handleLogsModalClose = () => {
    setShowLogsModal(false);
    setLogs(undefined);
    setLogsError(false);
    setSelectedExecution(application!.workflows[0].runs?.[0]?.k8sRunId);
  };

  const handlePreviewModalClose = () => {
    setShowPreviewModal(false);
    setPreview(undefined);
    setPreviewError(false);
    setPreviewDataset(undefined);
    setSelectedExecution(application!.workflows[0].runs?.[0]?.k8sRunId);
  }

  const getLogs = useCallback((download?: boolean, execution?: string) => {
    const params = new URLSearchParams();
    if (download) {
      showLoader();
      params.set('download', `${true}`);
    }
    else params.set('tail_lines', `${200}`);
    if (execution) {
      params.set('k8sRunId', execution);
      const namespace = application!.workflows[0].runs?.find((run) => run.k8sRunId === execution)?.namespace;
      if (namespace) params.set('namespace', namespace);
    } else {
      params.set('k8sRunId', selectedExecution!);
      const namespace = application!.workflows[0].runs?.find((run) => run.k8sRunId === selectedExecution!)?.namespace;
      if (namespace) params.set('namespace', namespace);
    }
    const
      appId = application!.id!,
      workflowId = application!.workflows[0].id!,
      serviceId = service!.id!;

    if (!download) {
      setLogs(undefined);
      setLogsError(false);
    }

    const promise = download
      ? K8sClient.downloadServiceLogs(appId, workflowId, serviceId, params)
      : K8sClient.getServiceLogs(appId, workflowId, serviceId, params);

    promise
      .then(
        ({ data: logs }) => {
          if (download) {
            hideLoader();
            const fileContent = new Blob([logs], { type: 'application/zip' });
            showToast('get-logs-success', `${serviceLabels.singular} logs ready to download.`, 'Logs Success', 'success');
            FileSaver.saveAs(fileContent, `${application!.name} - ${service!.name} Logs.zip`);
          }
          else setLogs(logs);
        },
        () => {
          if (download) hideLoader();
          else setLogsError(true);
          showToast('get-logs-error', `Could not get ${serviceLabels.singular} logs.`, 'Logs Error', 'danger');
        }
      )
  }, [service, application, hideLoader, showLoader, showToast, selectedExecution, serviceLabels]);

  const getDocumentation = useCallback(() => {
    Services.getServiceMarkDown(service!.id as number)
      .then(
        ({ data }) => setServiceMarkdown(data),
        (err) => {
          setMarkdownError(true);
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('service-markdown-error', message, `Service Documentation Error ${status ? `(${status})` : ''}`, 'danger');
        }
      );
  }, [service, showToast]);

  const handleDocumentationModalClose = useCallback(() => {
    setServiceMarkdown(undefined);
    setShowDocumentationModal(false);
  }, []);

  const handleShowDocumentation = useCallback(() => {
    setShowDocumentationModal(true);
    getDocumentation();
  }, [getDocumentation]);

  const handleShowLogs = useCallback(() => {
    setShowLogsModal(true);
    getLogs();
  }, [getLogs]);

  const handleAssetsModalClose = () => {
    setShowAssetsModal(false);
    setSelectedAsset(undefined);
    setSelectedExecution(application!.workflows[0].runs?.[0]?.k8sRunId);
  }

  const assetsOptions = useMemo(() => {
    if (!service) return [];
    const assetsProperty = service!.properties.find(prop => prop.key === 'assets');
    if (!assetsProperty) return [];
    const assets: AssetsPropertyValue = JSON.parse(assetsProperty?.value);
    // listing only outputs in download assets modal
    return [
      // ...(assets.inputs || []).map(asset => ({ label: `${asset?.name} (Input)` || '', value: asset?.name || '' })),
      ...(assets.outputs || []).map(asset => ({ label: asset?.name || '', value: asset?.name || '' })),
    ];
  }, [service]);

  const openAssetsModal = () => setShowAssetsModal(true);
  const handleCronError = (evt: any) => setCronError(evt?.description);
  const handleCustomCronChange = (evt: React.ChangeEvent<HTMLInputElement>) => setCustomCron(evt.target.value);
  const updateScheduleCron = () => {
    setNewSchedule({
      ...newSchedule,
      cronExpression: customCron!,
    });
  }

  const setDefaultVersion = (version: ApplicationVersion) => (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.stopPropagation();
    showLoader();

    Applications.setDefaultVersion(version.bdaId)
      .then(
        () => {
          hideLoader();
          showToast('app-version-success', `Updated ${application!.template ? 'template' : applicationLabels.singular} default version successfully`, "Default Version Updated", 'success');
          reload();
        },
        (err) => {
          hideLoader();
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('app-version-error', message, `Version Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const handleScheduleToggle = (index: number) => () => {
    const schedule = { ...application!.workflows[0].schedules![index] };
    const updatedSchedule = { ...schedule, suspend: !schedule.suspend };
    const promise = schedule.suspend
      ? Schedules.resumeSchedule(application!.id!, application!.workflows[0].id!, updatedSchedule)
      : Schedules.suspendSchedule(application!.id!, application!.workflows[0].id!, updatedSchedule);

    showLoader();

    promise.then(
      () => {
        hideLoader();
        reloadAppSchedules();
        showToast('schedule-toggle-success', `Schedule ${schedule.suspend ? "resumed" : "suspended"} successfully`, "Schedule Success", 'success');
      },
      (err) => {
        hideLoader();
        const message = err.response?.data?.message || err.message;
        const status = err.response?.status;
        showToast('schedule-toggle-error', message, `Schedule Error ${status ? `(${status})` : ''}`, 'danger');
      }
    )
  }

  const onShowPreview = () => {
    setShowPreviewModal(true);
    setPreviewDataset(dataset);
    getPreview(dataset!);
  }

  const downloadLogs = () => getLogs(true);

  const getPreview = (selectedDataset: BdaDataset) => {
    const _previewDataset = selectedDataset || previewDataset;
    const body = new QueryDetails(_previewDataset.datasource, _previewDataset.datasetFileType);

    VizClient.getDatasetPreview(body)
      .then(
        ({ data }) => setPreview(data || []),
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          setPreviewError(true);
          showToast('dataset-error', message, `${datasetLabels.singular} Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const reloadAppSchedules = () => {
    const newApp = cloneDeep(application!);
    set(newApp, 'workflows.0.schedules', null);
    setApplication(newApp);

    Schedules.getSchedules(application!.id!, application!.workflows[0].id!)
      .then(
        ({ data: schedules }) => {
          set(newApp, 'workflows.0.schedules', schedules);
          setApplication(newApp);
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('dataset-error', message, `${datasetLabels.singular} Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const deleteSchedule = () => {
    showLoader();

    Schedules.deleteSchedule(application!.id!, application!.workflows[0].id!, schedule!.id!)
      .then(
        () => {
          hideLoader();
          showToast("schedule-delete-success", `${applicationLabels.singular} Schedule deleted successfully`, "Schedule Success", "success")
          handleDeleteClose();
          reloadAppSchedules()
        },
        (err) => {
          hideLoader();
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('schedules-error', message, `Schedule Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const handleScheduleSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
    const form = evt.currentTarget;
    evt.preventDefault();
    evt.stopPropagation();
    setValidated(true);

    if (form.checkValidity() === true) {
      const promise = newSchedule.id
        ? Schedules.updateSchedule(application!.id!, application!.workflows[0].id!, newSchedule)
        : Schedules.createSchedule(application!.id!, application!.workflows[0].id!, newSchedule);

      showLoader();

      promise.then(
        () => {
          hideLoader();
          showToast("schedule-create-success", `${applicationLabels.singular} Schedule ${newSchedule.id ? 'updated' : 'created'} successfully`, "Schedule Success", "success")
          handleScheduleClose();
          reloadAppSchedules()
        },
        (err) => {
          hideLoader();
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('schedules-error', message, `Schedule Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
    }
  }

  const openRunModal = useCallback(() => setShowRunModal(true), []);
  const handleRunModalClose = useCallback(() => {
    setShowRunModal(false);
    setSelectedNamespace("alida");
  }, []);

  const runApplication = useCallback(() => {
    showLoader();
    const workflowId = application!.workflows[0].id!;
    const params = new URLSearchParams();
    params.append("namespace", selectedNamespace);

    Applications.runApplication(application!.id!, workflowId, params)
      .then(
        (_) => {
          showToast('bda-run-success', `${applicationLabels.singular} started successfully.`, 'Success', 'success');
          hideLoader();
          handleRunModalClose();
        },
        (err) => {
          showToast('bda-run-error', `Could not execute ${applicationLabels.singular}.`, `${applicationLabels.singular} Error`, 'danger');
          hideLoader();
        }
      );
  }, [application, handleRunModalClose, showLoader, hideLoader, selectedNamespace, showToast, applicationLabels]);

  const stopApplication = useCallback(() => {
    showLoader();
    const workflowId = application!.workflows[0].id!;

    Applications.stopApplication(application!.id!, workflowId)
      .then(
        (_) => {
          showToast('bda-stop-success', `${applicationLabels.singular} stopped successfully.`, 'Success', 'success');
          hideLoader();
        },
        (err) => {
          showToast('bda-stop-error', `Could not stop ${applicationLabels.singular}.`, `${applicationLabels.singular} Error`, 'danger');
          hideLoader();
        }
      );
  }, [application, showToast, showLoader, hideLoader, applicationLabels]);

  const toggleApplication = useCallback(() => {
    if (application!.status === "RUNNING" || application!.status === "PARTIAL" || application!.status === "STARTING") stopApplication();
    else {
      if (!applicationNamespaces || applicationNamespaces.length <= 1) runApplication();
      else openRunModal();
    }
  }, [application, stopApplication, openRunModal, runApplication, applicationNamespaces]);

  const openApplicationNotes = useCallback(() => setShowNotesModal(true), []);
  const openServiceNotes = useCallback(() => setShowServiceNotesModal(true), []);
  const handleCloseApplicationNotes = useCallback(() => setShowNotesModal(false), []);
  const handleCloseServiceNotes = useCallback(() => setShowServiceNotesModal(false), []);

  const downloadApplicationJSON = useCallback(() => {
    const applicationString = JSON.stringify(application);
    const blob = new Blob([applicationString], { type: 'application/json' });
    FileSaver.saveAs(blob, application!.name);
  }, [application]);

  // const downloadApplicationArchive = useCallback(() => {
  //   showLoader();

  //   const body = { ...exportOptions, bda: application };
  //   if (application!.workflows[0].mode === "BATCH") delete body.kafka;

  //   Applications.exportApplication(body)
  //     .then(
  //       ({ data: bundle }) => {
  //         hideLoader();
  //         const blob = new Blob([bundle], { type: exportOptions.rar ? 'application/tar' : 'application/zip' });
  //         FileSaver.saveAs(blob, `${application!.name}${exportOptions.rar ? '.tar' : '.zip'}`);
  //       },
  //       () => {
  //         hideLoader();
  //         showToast('bda-export-error', `Could not export ${applicationLabels.singular}.`, `${applicationLabels.singular} Error`, 'danger');
  //       }
  //     );
  // }, [exportOptions, application, showLoader, hideLoader, showToast, applicationLabels]);

  const downloadApplicationManifest = useCallback(() => {
    showLoader();

    Applications.downloadManifest(application!.id!, application!.workflows[0]!.id!)
      .then(
        ({ data }) => {
          hideLoader();
          const blob = new Blob([data], { type: 'application/json' });
          FileSaver.saveAs(blob, `${application!.name} Manifest.json`);
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('manifest-download-error', message, `Manifest Download Error ${status ? `(${status})` : ''}`, 'danger');
          hideLoader();
        }
      )
  }, [showLoader, hideLoader, showToast, application]);

  const cloneApplication = useCallback(() => {
    showLoader();

    Applications.cloneApplication(application!.id as number)
      .then(
        ({ data }) => {
          hideLoader();
          handleExportClose();
          setShowCloneModal(true);
          setApplicationClone(data);
        },
        (err) => {
          hideLoader();
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('application-clone-error', message, `${applicationLabels.plural} Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }, [showLoader, hideLoader, showToast, application, applicationLabels]);

  const exportApplication = useCallback(() => {
    if (exportMode === 'cluster') downloadApplicationJSON();
    else if (exportMode === 'manifest') downloadApplicationManifest();
    else cloneApplication(); // exportMode === 'clone'
    // else downloadApplicationArchive();
  }, [downloadApplicationJSON, exportMode, downloadApplicationManifest, cloneApplication]);

  const deleteApplication = () => {
    showLoader();

    Applications.deleteApplication(application!.id!)
      .then(
        () => {
          showToast('bda-delete-success', `${application!.template ? 'Template' : applicationLabels.singular} deleted successfully.`, 'Success', 'success');
          hideLoader();
          handleDeleteClose();
          navigate('/bda-applications');
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('bda-delete-error', message, `${application!.template ? 'Template' : applicationLabels.singular} Error ${status ? `(${status})` : ''}`, 'danger');
          hideLoader();
        }
      );
  };

  const openDatasetPreview = (dataset: BdaDataset) => () => {
    setShowPreviewModal(true);
    setPreviewDataset(dataset);
    getPreview(dataset);
  }

  const handleOpenServicePropertiesModal = useCallback(() => setShowEditServicePropertiesModal(true), []);
  const handleCloseServicePropertiesModal = useCallback(() => {
    setShowEditServicePropertiesModal(false);
    setServiceProperties(undefined);
  }, []);

  const copyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(JSON.stringify(SMART_UPDATE_EXAMPLE_PAYLOAD, null, 4));
    showToast('text-copied', 'Value copied to clipboard!');
  }, [showToast]);

  const toggleSmartEditExample = useCallback(() => setShowSmartUpdateExample(v => !v), []);

  const handleEditServicePropertiesSubmit = useCallback(() => {
    showLoader();
    Applications.editServiceProperties(application!.id!, JSON.parse(serviceProperties!))
      .then(
        ({ data }) => {
          hideLoader();
          showToast("edit-properties-success", `${serviceLabels.singular} Properties edited successfully`, `${serviceLabels.singular} Properties Success`, "success");
          handleCloseServicePropertiesModal();
          navigate(`/bda-applications/${data.id}`);
          closeElementDetail();
          reload();
        },
        (err) => {
          hideLoader();
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('edit-properties-error', message, `${serviceLabels.singular} Properties Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }, [showLoader, application, handleCloseServicePropertiesModal, hideLoader, navigate, serviceProperties, showToast, serviceLabels, reload]);

  const handleRunClose = useCallback(() => {
    setSelectedRun(undefined);
    // setCurrentGraph(application.workflows[0].procedure);
    const graph = translateGraph(application!.workflows[0].procedure);
    setNodes(graph.nodes);
    setEdges(graph.edges);
  }, [application, setNodes, setEdges]);

  const toggleRunSelection = useCallback((run: Execution) => () => {
    if (selectedRun?.id === run.id) handleRunClose();
    else {
      setSelectedRun(run);
      // update workflow graph
      const newGraph = translateGraph(application!.workflows[0].procedure);
      run.servicesStatus?.forEach(s => {
        const serviceIndex = newGraph.nodes.findIndex(el => el.id === s.serviceRef);

        if (serviceIndex < 0) return;

        if (!newGraph.nodes[serviceIndex].data.statusModel) newGraph.nodes[serviceIndex].data.statusModel = {};
        newGraph.nodes[serviceIndex].data.statusModel.status = s.serviceStatus;
      });
      setNodes(newGraph.nodes);
      setEdges(newGraph.edges);
    }
    // setCurrentGraph(newGraph);
  }, [selectedRun, handleRunClose, application, setEdges, setNodes]);

  const handleSelectedExecutionChange = useCallback((value: string) => {
    setSelectedExecution(value);
    getLogs(false, value);
  }, [getLogs]);

  const downloadModel = (model: BdaModel) => () => {
    Models.downloadModel(model.id)
      .then(
        ({ data: modelToDownload }) => {
          const blob = new Blob([modelToDownload], { type: 'application/zip' });
          FileSaver.saveAs(blob, `${model.name}.zip`);
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('models-error', message, `${modelLabels.singular} Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const handleRestartService = useCallback(() => {
    const workflowId = application!.workflows[0].id as number;
    const namespace = application!.workflows[0].runs!.find((run) => run.k8sRunId === selectedExecution!)!.namespace;
    const params = new URLSearchParams([
      ['namespace', namespace!],
      ['k8sRunId', selectedExecution!],
    ]);

    showLoader();

    K8sClient.restartService(+id!, workflowId, service!.id!, params)
      .then(
        () => {
          hideLoader();
          showToast('service-restart-success', `${serviceLabels.singular} restarted successfully`, `${serviceLabels.singular} Success`, 'success');
        },
        (err) => {
          hideLoader();
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('service-restart-error', message, `${serviceLabels.singular} Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }, [id, application, showLoader, hideLoader, serviceLabels, showToast, service, selectedExecution]);

  const downloadFile = useCallback((file: AssetFile) => () => {
    showLoader();
    const returnRawFile = file.messageType === 'html' || file.extension === 'zip';
    const body = {
      type: file.messageType,
      path: file.path,
      returnRawFile,
    };

    Applications.getApplicationAssetFilesByDetails(+id!, body, returnRawFile ? { responseType: 'blob' } : undefined)
      .then(
        ({ data }) => {
          hideLoader();
          const fileContent = typeof data === 'object' && data.content ? atob(data.content) : data;
          const blob = new Blob([fileContent], file.extension === 'zip' ? { type: 'application/zip' } : undefined);
          FileSaver.saveAs(blob, `${file.name}.${file.extension}`);
        },
        (err) => {
          hideLoader();
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('file-download-error', message, `Download Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }, [id, showLoader, hideLoader, showToast]);

  const openProjectsModal = () => setShowProjectsModal(true);
  const handleProjectsModalClose = () => setShowProjectsModal(false);

  const renderDatasetPreview = useCallback(() => {
    if (previewError) return (
      <Alert variant="danger">
        <FontAwesomeIcon icon={solid('exclamation-triangle')} />
        <span className="ms-2">An error occurred, please try again later.</span>
      </Alert>
    )

    if (!preview) return <AppLoader size={100} className="py-5" />;

    return preview.length
      ? (
        <div className="table-wrapper">
          <Table bordered>
            <thead>
              <tr>
                {Object.keys(preview[0]).map(key => (
                  <th key={key}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {preview.map((row, i) => (
                <tr key={i}>
                  {Object.keys(row).map((col, j) => (
                    <td key={j}>{row[col]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )
      : (
        <Alert className="pfy-2 mb-0">
          <FontAwesomeIcon icon={solid('info-circle')} />
          <span className="ms-2">{datasetLabels.singular} is empty</span>
        </Alert>
      )
  }, [datasetLabels, preview, previewError]);

  const renderServiceLogs = useCallback(() => {
    return (
      <>
        <Flex align="center" className="mb-3">
          <Form.Label className="ms-auto me-3">Execution</Form.Label>
          <Col md={4}>
            <Select
              placeholder={`${applicationLabels.singular} Execution`}
              className="w-100"
              value={selectedExecution}
              onChange={handleSelectedExecutionChange}
              options={executionsOptions}
            />
          </Col>
        </Flex>
        {logsError ? (
          <Alert variant="danger">
            <FontAwesomeIcon icon={solid('exclamation-triangle')} />
            <span className="ms-2">An error occurred, please try again later.</span>
          </Alert>
        ) : (
          <>
            {!logs ? (
              <div className="d-flex justify-content-center py-5">
                <AlidaLoader size={300} />
              </div>
            ) : (
              <div className="service-logs">
                {(logs.messages[0] as string).split("\n").map((line, index) => (
                  <code key={index} className="d-block">{line}</code>
                ))}
              </div>
            )}
          </>
        )}
      </>
    )
  }, [applicationLabels, logsError, logs, executionsOptions, handleSelectedExecutionChange, selectedExecution]);

  const handleDownloadAsset = () => {
    const params = new URLSearchParams();
    params.set("k8sRunId", selectedExecution!);
    params.set("assetName", selectedAsset!);
    const namespace = application!.workflows[0].runs?.find((run) => run.k8sRunId === selectedExecution)?.namespace;
    if (namespace) params.set("namespace", namespace);

    const
      bdaId = application!.id,
      workflowId = application!.workflows[0].id!,
      serviceId = service!.id;

    showLoader();

    K8sClient.downloadServiceAsset(bdaId!, workflowId, serviceId!, params)
      .then(
        ({ data: file }) => {
          const fileContent = new Blob([file], { type: 'application/tar' });
          showToast('get-asset-success', `${serviceLabels.singular} File ready to download.`, 'Logs Success', 'success');
          FileSaver.saveAs(fileContent, `${application!.name} - ${service!.name} - Asset ${selectedAsset}.tar`);
          hideLoader();
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('app-asset-error', message, `Asset Error ${status ? `(${status})` : ''}`, 'danger');
          hideLoader();
        }
      )
  }

  const renderServiceAssets = () => {
    return (
      <div>
        <div className="d-flex align-items-center mb-3">
          <Col md={4}>
            <Form.Label>Execution</Form.Label>
          </Col>
          <Select placeholder={`${applicationLabels.singular} Execution`} className="w-100" value={selectedExecution} onChange={setSelectedExecution} options={executionsOptions} />
        </div>
        {assetsOptions.length === 0
          ? (
            <Alert variant="info" className="m-0 py-2">
              <FontAwesomeIcon icon={solid('info-circle')} />
              <span className="ms-2">No assets found for this execution.</span>
            </Alert>
          )
          : (
            <div className="d-flex align-items-center mb-3">
              <Col md={4}>
                <Form.Label>Asset</Form.Label>
              </Col>
              <Select className="w-100" placeholder="Select an asset..." value={selectedAsset} options={assetsOptions} onChange={setSelectedAsset} />
            </div>
          )}
      </div>
    )
  }

  const renderAssetFiles = () => {
    return (
      <div>
        <div className="d-flex align-items-center mb-3">
          <Col md={4}>
            <Form.Label>Execution</Form.Label>
          </Col>
          <Select placeholder={`${applicationLabels.singular} Execution`} className="w-100" value={selectedExecution} onChange={setSelectedExecution} options={executionsOptions} />
        </div>

        {!assetFiles && <AppLoader className="py-5" justify="center" size={100} />}

        {assetFiles?.length === 0 && (
          <Alert variant="info" className="m-0 py-2">
            <FontAwesomeIcon icon={solid('info-circle')} />
            <span className="ms-2">No media found for this {applicationLabels.singular}.</span>
          </Alert>
        )}

        {
          assetFiles
            ?.sort((a, b) => isAfter(new Date(a.modified), new Date(b.modified)) ? -1 : 1)
            .map(file => <AssetFileItem key={file.uuid} file={file} onDownload={downloadFile(file)} service={getAssetFileService(file)} />)
        }
      </div>
    )
  }

  const renderApplicationMedia = () => {
    return (
      <>
        <button className="versions-toggle" onClick={onShowNotifications}>
          <FontAwesomeIcon icon={regular('images')} />
          <span className="ms-2">{applicationLabels.singular} Media</span>
        </button>

        <Offcanvas show={showNotifications} onHide={handleNotificationsClose} placement="end">
          <Offcanvas.Header className="border-bottom" closeButton>
            <h6 className="m-0">{applicationLabels.singular} Media</h6>
          </Offcanvas.Header>
          <Offcanvas.Body className="p-2">
            {renderAssetFiles()}
          </Offcanvas.Body>
        </Offcanvas>
      </>
    )
  }

  const renderVersions = () => {
    return (
      <>
        <button className="ms-2 versions-toggle" onClick={onShowVersions}>
          <FontAwesomeIcon icon={solid('tag')} />
          <span className="ms-2">Version {application!.version}</span>

          <FontAwesomeIcon className="ms-3" icon={solid('chevron-down')} />
        </button>

        <Offcanvas show={showVersions} onHide={handleVersionsClose} placement="end">
          <Offcanvas.Header className="border-bottom" closeButton>
            <h6 className="m-0">{application!.template ? 'Template' : applicationLabels.singular} Versions</h6>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {application!.versions
              ?.sort((a, b) => b.version - a.version)
              .map(version => (
                <div key={version.version} className={classNames("version-item", { selected: version.bdaId === +id! })} onClick={changeAppVersion(version)}>
                  <div className="pe-3">
                    <FontAwesomeIcon icon={solid('tag')} />
                  </div>
                  <Col>
                    <h6 className="mb-0">{version.version}</h6>
                    <span className="text-muted">{formatDate(version.createdDate)}</span>
                  </Col>
                  <IconButton onClick={setDefaultVersion(version)} tooltip="Default version">
                    <FontAwesomeIcon className={classNames({ "text-warning": version.defaultVersion })} icon={version.defaultVersion ? solid('star') : regular('star')} />
                  </IconButton>
                </div>
              ))}
          </Offcanvas.Body>
        </Offcanvas>
      </>
    )
  }

  const renderEnvVarModal = useCallback(() => (
    <>
      {selectedEnvironmentVariables && (
        <Row className="gap-3">
          {
            Object.entries(selectedEnvironmentVariables!).map(([key, value], index) => {
              return (
                <Row className="justify-content-around" key={index}>
                  <Col xs={4}>
                    <b>{key}</b>
                  </Col>
                  <Col xs={8}>
                    {getStringType(value) === "json"
                      ? <ScriptEditor readOnly value={value} height={200} />
                      : <span className="font-monospace text-muted font-smaller">{value}</span>
                    }
                  </Col>
                </Row>
              )
            })
          }
        </Row>
      )}
    </>
  ), [selectedEnvironmentVariables]);

  const handleEnvVarsModalClick = (run: Execution) => (evt: React.MouseEvent<HTMLElement>) => {
    evt.preventDefault();
    evt.stopPropagation();
    setSelectedEnvironmentVariables(run.environmentVariables);
    setShowEnvVarsModal(true);
  };

  const handleEnvVarsModalClose = () => {
    setShowEnvVarsModal(false);
    setSelectedEnvironmentVariables(undefined);
  }

  const handleErrors = (errors: editor.IMarker[]) => setInvalidProperties(errors.length > 0);

  const createTemplateFromApplication = useCallback((evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.stopPropagation();
    showLoader();

    Applications.createTemplate(application!.id!)
      .then(
        ({ data }) => {
          hideLoader();
          showToast('create-template-success', 'Template created successfully.', 'Success', 'success');
          navigate(`/bda-applications/${data.id}`);
        },
        (err) => {
          hideLoader();
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('create-template-error', message, `Template Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }, [application, hideLoader, showLoader, showToast, navigate]);

  const renderApplicationRuns = useCallback(() => {
    return (
      <div className="element-detail">
        <div className="element-detail-header">
          <h6 className="mb-0 me-2">{applicationLabels.singular} Executions</h6>

          <IconButton onClick={closeElementDetail}>
            <FontAwesomeIcon icon={solid('times')} />
          </IconButton>
        </div>

        <div className="element-detail-body p-0">
          {runs!.length === 0 && (
            <Alert className="py-2 m-2">
              <FontAwesomeIcon icon={solid('info-circle')} />
              <span className="ms-2">No executions found for this {applicationLabels.singular}.</span>
            </Alert>
          )}

          {runs!.length > 0 && (
            <ListGroup>
              {runs!
                .sort((a, b) => isBefore(a.startDate ? new Date(a.startDate) : new Date(a.dateOfLastStatus), b.startDate ? new Date(b.startDate) : new Date(b.dateOfLastStatus)) ? 1 : -1)
                .map((run: Execution) => (
                  <ListGroup.Item className={classNames("run-item", { selected: selectedRun?.id === run.id })} key={run.id}>
                    <AntButton
                      onClick={toggleRunSelection(run)}
                      color="primary"
                      shape="circle"
                      variant="dashed"
                      icon={selectedRun?.id === run.id ? (
                        <FontAwesomeIcon icon={solid("times")} fixedWidth />
                      ) : (
                        <>
                          {run.runType === "SCHEDULED" ? <FontAwesomeIcon icon={regular("clock")} fixedWidth /> : <FileSearchOutlined />}
                        </>
                      )}
                    />

                    <div className="ps-3 w-100">
                      <Flex justify="space-between">
                        {run.startDate && <h6 className="mb-1">{formatDate(run.startDate)}</h6>}
                        {run.namespace && (
                          <Tooltip title="Namespace">
                            <Tag color="orange" className="m-0 align-self-start">
                              <FontAwesomeIcon icon={solid("circle-nodes")} />
                              <span className="ms-1 text-uppercase">{run.namespace}</span>
                            </Tag>
                          </Tooltip>
                        )}
                      </Flex>
                      {getStatusBadge(run.currentStatus)}
                      {run.dateOfLastStatus && (
                        <Badge bg="light" className="border text-dark ms-2">
                          <FontAwesomeIcon icon={regular('clock')} />
                          <span className="ms-1">{getExecutionTime(run.startDate, run.dateOfLastStatus)}</span>
                        </Badge>
                      )}
                      {run.environmentVariables && (
                        <Badge bg="light" as="button" onClick={handleEnvVarsModalClick(run)} className="border text-dark ms-2">
                          <FontAwesomeIcon icon={solid('code')} />
                          <span className="ms-2 text-uppercase">{environmentVariablesLabels.plural}</span>
                        </Badge>
                      )}
                    </div>
                  </ListGroup.Item>
                ))}
            </ListGroup>
          )}
        </div>
      </div>
    )
  }, [runs, toggleRunSelection, selectedRun, applicationLabels, environmentVariablesLabels]);

  const renderModelDetail = () => {
    return (
      <div className="element-detail">
        <div className="element-detail-header">
          <Link to={`/models/${model!.id}`} target="_blank" rel="noopener noreferer">
            <h6 className="d-inline-block mb-0 me-2">{model!.name}</h6>
            <FontAwesomeIcon size="sm" icon={solid('external-link-alt')} />
            {model!.deleteDateTime && (<Tag color="red" className="shadow text-uppercase font-xs fw-bold m-0 ms-2">Deprecated</Tag>)}
          </Link>

          <IconButton onClick={closeElementDetail}>
            <FontAwesomeIcon icon={solid('times')} />
          </IconButton>
        </div>

        <div className="element-detail-body">
          <div className="mb-2">
            <Form.Label>Algorithm</Form.Label>
            <code className="d-block">{model!.algorithmName}</code>
          </div>
          <div className="mb-2">
            <Form.Label>Location</Form.Label>
            <code className="d-block">{model!.location}</code>
          </div>
          <div className="mb-2">
            <Form.Label>Input Columns</Form.Label>
            <code className="d-block">{model!.inputs}</code>
          </div>
          <div className="mb-2">
            <Form.Label>Dataset</Form.Label>
            <code className="d-block">{model!.trainingDataset.name}</code>
          </div>

          <h6>Properties</h6>
          <Table className="table-schema" bordered>
            <thead className="bg-light">
              <tr>
                <th>Name</th>
                <th className="text-center" style={{ width: "40%" }}>Value</th>
              </tr>
            </thead>
            <tbody>
              {model!.properties?.map((prop, index) => {
                const key = Object.keys(prop)[0];
                return (
                  <tr key={index}>
                    <td>{key}</td>
                    <td className="text-center">
                      <small className="text-muted text-uppercase">{prop[key]}</small>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </div>
      </div>
    )
  }

  const renderDatasetDetail = () => {
    return (
      <div className="element-detail">
        <div className="element-detail-header">
          <Link to={`/datasets/${dataset!.id}`} target="_blank" rel="noopener noreferer">
            <h6 className="d-inline-block mb-0 me-2">{dataset!.name}</h6>
            <FontAwesomeIcon size="sm" icon={solid('external-link-alt')} />
            {dataset!.deleteDateTime && (<Tag color="red" className="shadow text-uppercase font-xs fw-bold m-0 ms-2">Deprecated</Tag>)}
          </Link>

          <IconButton onClick={closeElementDetail}>
            <FontAwesomeIcon icon={solid('times')} />
          </IconButton>
        </div>

        <div className="element-detail-body">
          <div className="mb-2">
            <Form.Label>{datasourceLabels.singular}</Form.Label>
            <code className="d-block">{dataset!.datasource!.name}</code>
          </div>

          <div className="mb-2">
            <Form.Label>Type</Form.Label>
            <code className="d-block">{dataset!.datasetFileType!.type}</code>
          </div>

          {dataset!.datasetFileType!.type === "table" &&
            (
              <>
                <h6>{datasetLabels.singular} Columns</h6>
                <Table className="table-schema" bordered>
                  <thead className="bg-light">
                    <tr>
                      <th>Name</th>
                      <th className="text-center" style={{ width: "40%" }}>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataset!.datasetFileType?.columns?.map((col, index) => (
                      <tr key={col.name}>
                        <td>{col.name}</td>
                        <td className="text-center">
                          <small className="text-muted text-uppercase">{col.type}</small>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}
        </div>

        {dataset!.datasetFileType!.type === "table" && (
          <div className="element-detail-footer">
            <Button size="sm" variant="light" className="border" onClick={onShowPreview}>
              <FontAwesomeIcon icon={solid('eye')} />
              <span className="ms-2">Show Preview</span>
            </Button>
          </div>
        )}
      </div>
    )
  }

  const copyServiceUrl = useCallback((internal: boolean) => () => {
    navigator.clipboard.writeText(internal ? serviceInternalUrl : serviceExternalUrl);
    showToast('text-copied', `${internal ? "Internal" : "External"} URL copied to clipboard!`);
  }, [showToast, serviceInternalUrl, serviceExternalUrl]);

  const navigateToServiceProperties = useCallback((serviceId: number) => () => {
    navigate(`/bda-applications/${id}/services/${serviceId}`);
  }, [navigate, id]);

  const renderServiceDetail = useCallback(() => {
    return (
      <div className="element-detail">
        <div className="element-detail-header">
          <Link to={`/services/${service!.id}`} target="_blank" rel="noopener noreferer">
            <h6 className="d-inline-block mb-0 me-2">{service!.name}</h6>
            <FontAwesomeIcon size="sm" icon={solid('external-link-alt')} />
            {service!.deleteDateTime && (<Tag color="red" className="shadow text-uppercase font-xs fw-bold m-0 ms-2">Deprecated</Tag>)}
          </Link>

          <IconButton onClick={closeElementDetail}>
            <FontAwesomeIcon icon={solid('times')} />
          </IconButton>
        </div>

        <div className="element-detail-body">
          <p>{service!.description}</p>
          <Flex align="center" justify="space-between" className="mb-2">
            <Form.Label>Label</Form.Label>
            <div>{service!.label || service!.name}</div>
          </Flex>

          <Flex align="center" justify="space-between" className="mb-2">
            <Form.Label>Version</Form.Label>
            <Badge bg="light" className="border text-dark">
              <FontAwesomeIcon icon={solid('tag')} />
              <span className="ms-2">{service!.version}</span>
            </Badge>
          </Flex>

          {service!.statusModel && (
            <>
              <Flex justify="space-between" className="mb-2">
                <Form.Label>Status</Form.Label>
                <div className="px-0 text-end">{getStatusBadge(service!.statusModel.status)}</div>
              </Flex>
              {service!.statusModel.message && (
                <Flex justify="space-between" className="mb-2">
                  <Form.Label>Message</Form.Label>
                  <div className="px-0 text-end font-monospace text-danger font-sm w-75">{service!.statusModel.message}</div>
                </Flex>
              )}
              {service!.statusModel.status === "COMPLETED" && (
                <Flex justify="space-between" className="mb-2">
                  <Form.Label>Execution Time</Form.Label>
                  <Badge bg="light" className="border text-dark">
                    <FontAwesomeIcon icon={regular('clock')} />
                    <span className="ms-1">{getExecutionTime(service!.statusModel.initTime, service!.statusModel.endTime)}</span>
                  </Badge>
                </Flex>
              )}
            </>
          )}

          <Flex className="mb-2" justify="space-between" align="center">
            <Form.Label>Owner</Form.Label>
            <UserItem className="w-50 sm border p-1 rounded" user={service!.owner} organization={service!.organization} />
          </Flex>

          {service!.category?.name === "Agent" && window.__env.LANGFUSE_TRACES_URL && (
            <Alert variant="secondary" className="my-2 py-2 align-items-center text-center">
              <p className="m-0">
                <FontAwesomeIcon icon={solid('info-circle')} />
                <span className="ms-2 me-1">Tracing is available for this {serviceLabels.singular}:</span>
                <a href={`${window.__env.LANGFUSE_TRACES_URL}${service!.id}`} target="_blank" rel="noopener noreferrer">
                  <h6 className="d-inline-block mb-0 me-2">Visit {serviceLabels.singular} Tracing</h6>
                  <FontAwesomeIcon size="sm" icon={solid('external-link-alt')} />
                </a>
              </p>
            </Alert>
          )}

          {serviceIsExposable && (
            <Alert variant="primary" className="my-2 py-2 align-items-center text-center">
              <div className="mb-1">
                <FontAwesomeIcon icon={solid('info-circle')} />
                <span className="ms-2 me-auto">{serviceLabels.singular} is exposed on the web and can be reached through the URLs below.</span>
              </div>
              {service!.statusModel?.status !== ExecutionStatus.RUNNING
                ? <span className="text-muted">-- Available as soon as the service starts its execution --</span>
                : (
                  <Flex align="center" justify="center" gap={8}>
                    <Tooltip title={`External URL: ${serviceExternalUrl}`}>
                      <Tag color="blue" className="text-truncate max-w-200 action p-1 px-3 rounded-pill" onClick={copyServiceUrl(false)}>
                        <FontAwesomeIcon icon={solid("copy")} className="me-2" />
                        <span className="text-truncate">{serviceExternalUrl}</span>
                      </Tag>
                    </Tooltip>
                    <Tooltip title={`Internal URL: ${serviceInternalUrl}`}>
                      <Tag color="blue" className="text-truncate max-w-200 action p-1 px-3 rounded-pill" onClick={copyServiceUrl(true)}>
                        <FontAwesomeIcon icon={solid("copy")} className="me-2" />
                        <span className="text-truncate">{serviceInternalUrl}</span>
                      </Tag>
                    </Tooltip>
                  </Flex>
                )
              }
            </Alert>
          )}

          {service!.properties
            .filter(prop => !!prop.value)
            .map(prop => (
              <div className="mb-2" key={prop.id}>
                <Form.Label>{prop.key}</Form.Label>
                {prop.extra?.mode === 'streaming'
                  ? renderTopicLink(prop.value)
                  : <code className="d-block">{(prop as BdaServiceApplicationProperty).obfuscated ? '******' : prop.value}</code>
                }
              </div>
            ))}
        </div>

        {(!application!.template || service!.notes) && (
          <div className="element-detail-footer">
            {showRetryButton && (
              <Button size="sm" variant="light" className="border me-2" onClick={handleRestartService}>
                <FontAwesomeIcon icon={solid('arrows-rotate')} />
                <span className="ms-2">Restart Service</span>
              </Button>
            )}
            <Button size="sm" variant="light" className="border me-2" onClick={handleShowLogs} disabled={logsButtonDisabled}>
              <FontAwesomeIcon icon={solid('align-left')} />
              <span className="ms-2">Show Logs</span>
            </Button>
            <Button size="sm" variant="light" className="border me-2" onClick={handleShowDocumentation}>
              <FontAwesomeIcon icon={solid('file-text')} />
              <span className="ms-2">Documentation</span>
            </Button>
            <Button size="sm" variant="light" className="border me-2" onClick={navigateToServiceProperties(service!.id!)}>
              <FontAwesomeIcon icon={solid('gears')} />
              <span className="ms-2">Edit Properties</span>
            </Button>
            {service!.notes && (
              <Button size="sm" variant="light" className="border" onClick={openServiceNotes}>
                <FontAwesomeIcon icon={solid('comment')} />
                <span className="ms-2">{serviceLabels.singular} Notes</span>
              </Button>
            )}
            {showDownloadAssets && (
              <Button size="sm" variant="light" className="border" onClick={openAssetsModal}>
                <FontAwesomeIcon icon={solid('download')} />
                <span className="ms-2">Download Assets</span>
              </Button>
            )}
          </div>
        )}
      </div>
    )
  }, [application, handleShowLogs, handleShowDocumentation, logsButtonDisabled, service, serviceIsExposable, serviceLabels, showDownloadAssets, showRetryButton, openServiceNotes, copyServiceUrl, serviceInternalUrl, serviceExternalUrl, handleRestartService, navigateToServiceProperties]);

  const renderDatasetBedge = (dataset: BdaDataset) => {
    var text, background;

    if (!dataset.createdBy) {
      text = "IN";
      background = "success";
    }
    else if (dataset.type === "STATISTICS") {
      text = dataset.type;
      background = "primary";
    }
    else if (dataset.createdByBdaId === +id!) {
      text = "OUT";
      background = "danger";
    }

    return <Badge bg={background}>{text}</Badge>
  }

  const renderModelBedge = (model: BdaModel) => {
    const text = model.createdByBdaId === +id! ? "OUT" : "IN";
    const background = model.createdByBdaId === +id! ? "danger" : "success";

    return <Badge bg={background}>{text}</Badge>
  }

  const renderApplicationGroups = () => {
    return (
      <>
        <AntCollapse ghost>
          <AntCollapse.Panel
            className="no-padding mb-2"
            showArrow={false}
            header={
              <>
                <FontAwesomeIcon icon={groupsIcons.datasets} fixedWidth />
                <span className="ms-2">{datasetLabels.plural}</span>
              </>
            }
            key="datasets"
          >
            {application!.datasets?.length === 0 && (
              <Alert className="py-2">
                <FontAwesomeIcon icon={solid('info-circle')} />
                <span className="ms-2">No {datasetLabels.plural} found for this {application!.template ? 'template' : applicationLabels.singular}.</span>
              </Alert>
            )}

            {application!.datasets && application!.datasets.length > 0 && (
              <ListGroup>
                {application!.datasets?.map(dataset => (
                  <ListGroupItem key={dataset.id} className="d-flex align-items-center">
                    <div className="pe-3">{renderDatasetBedge(dataset)}</div>

                    <Col>
                      <h6 className="mb-0">
                        <Link to={`/datasets/${dataset.id}`} target="_blank" rel="noopener noreferrer">{dataset.name}</Link>
                      </h6>
                      <small className="text-muted">{formatDate(dataset.createDateTime!)}</small>
                    </Col>

                    {dataset.created && dataset.datasetFileType?.type === 'table' && dataset.type !== 'STATISTICS' && (
                      <IconButton onClick={openDatasetPreview(dataset)} tooltip="Preview">
                        <FontAwesomeIcon icon={solid('eye')} />
                      </IconButton>
                    )}
                  </ListGroupItem>
                ))}
              </ListGroup>
            )}
          </AntCollapse.Panel>

          <AntCollapse.Panel
            className="no-padding mb-2"
            showArrow={false}
            header={
              <>
                <FontAwesomeIcon icon={groupsIcons.models} fixedWidth />
                <span className="ms-2">{modelLabels.plural}</span>
              </>
            }
            key="models"
          >
            {application!.models?.length === 0 && (
              <Alert className="py-2">
                <FontAwesomeIcon icon={solid('info-circle')} />
                <span className="ms-2">No {modelLabels.plural} found for this {application!.template ? 'template' : applicationLabels.singular}.</span>
              </Alert>
            )}

            {application!.models && application!.models.length > 0 && (
              <ListGroup>
                {application!.models.map(model => (
                  <ListGroupItem key={model.id} className="d-flex align-items-center">
                    <div className="pe-3">{renderModelBedge(model)}</div>

                    <Col>
                      <h6 className="mb-0">
                        <Link to={`/models/${model.id}`} target="_blank" rel="noopener noreferrer">{model.name}</Link>
                      </h6>
                      <Badge bg="none" className="border text-muted me-2" pill>
                        <FontAwesomeIcon icon={solid('cubes')} />
                        <span className="ms-2">Created by {serviceLabels.singular}: {model.algorithmName}</span>
                      </Badge>
                      <small className="text-muted">{formatDate(model.createDateTime)}</small>
                    </Col>

                    {model.created && (
                      <IconButton onClick={downloadModel(model)} tooltip="Download">
                        <FontAwesomeIcon icon={solid('download')} />
                      </IconButton>
                    )}
                  </ListGroupItem>
                ))}
              </ListGroup>
            )}
          </AntCollapse.Panel>

          {!application!.template && (
            <AntCollapse.Panel
              header={
                <>
                  <FontAwesomeIcon icon={groupsIcons.schedules} fixedWidth />
                  <span className="ms-2">Schedules</span>
                </>
              }
              key="schedules"
              className="no-padding mb-2"
              showArrow={false}
              extra={
                <button className="add-schedule-btn" onClick={openScheduleModal}>
                  <FontAwesomeIcon icon={solid('plus')} />
                  <span className="ms-2">Add Schedule</span>
                </button>
              }>
              {!application!.workflows[0].schedules && <AppLoader className="p-3" justify="center" size={100} />}

              {application!.workflows[0].schedules?.length === 0 && (
                <Alert className="py-2">
                  <FontAwesomeIcon icon={solid('info-circle')} />
                  <span className="ms-2">No schedules found for this {applicationLabels.singular}.</span>
                </Alert>
              )}

              {application!.workflows[0].schedules && application!.workflows[0].schedules.length > 0 && (
                <ListGroup>
                  {application!.workflows[0].schedules.map((schedule, index) => (
                    <ListGroupItem className="d-flex align-items-center" key={schedule.id}>
                      <div className="pe-3">
                        <FontAwesomeIcon className={classNames("schedule-icon", { active: !schedule.suspend })} size="lg" icon={regular('clock')} />
                      </div>

                      <Col>
                        <h6 className="mb-0">{schedule.name}</h6>
                        <span className="text-muted">{schedule.cronExpression}</span>
                      </Col>

                      <Col md={2} className="text-end">
                        <IconButton onClick={handleScheduleToggle(index)} tooltip="Toggle Schedule">
                          <FontAwesomeIcon className={schedule.suspend ? 'text-success' : 'text-warning'} icon={schedule.suspend ? solid('play') : solid('pause')} />
                        </IconButton>
                        <IconButton className="ms-2" onClick={handleScheduleEdit(index)} tooltip="Edit">
                          <FontAwesomeIcon icon={solid('pen')} />
                        </IconButton>
                        <IconButton className="ms-2 text-danger" onClick={openDeleteScheduleModal(schedule)} tooltip="Delete">
                          <FontAwesomeIcon icon={solid('trash')} />
                        </IconButton>
                      </Col>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              )}
            </AntCollapse.Panel>
          )}
        </AntCollapse>
      </>
    )
  }

  const handleGetDeploymentSuggestions = useCallback(() => {
    showLoader();

    Applications.getDeploymentSuggestions(application!.id!)
      .then(
        ({ data }) => {
          setDeploymentSuggestions(data.annotations);
          hideLoader();
          setShowDeploymentSuggestionsModal(true);
        },
        (err) => {
          hideLoader();
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('deployment-suggestions-error', message, `${serviceLabels.singular} Deployment Suggestions Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }, [showToast, showLoader, hideLoader, serviceLabels, application]);

  const handleDeploymentSuggestionsModalClose = useCallback(() => {
    setShowDeploymentSuggestionsModal(false);
    setDeploymentSuggestions(undefined);
  }, []);

  const renderDeploymentSuggestions = useCallback(() => {
    if ((deploymentSuggestions || []).length === 0) return (
      <Alert variant="info" className="py-2">
        <FontAwesomeIcon icon={solid('info-circle')} />
        <span className="ms-2">No suggestions found.</span>
      </Alert>
    );

    return (deploymentSuggestions || []).map((item, index) => (
      <Tooltip key={index} title={item} mouseEnterDelay={1}>
        <Flex align="center" className="text-primary p-1 px-2 mb-2 border rounded bg-light">
          <FontAwesomeIcon className="ms-1" icon={solid('info-circle')} />
          <span className="ms-2 pe-2 line-clamp-3">{item}</span>
        </Flex>
      </Tooltip>
    ))
  }, [deploymentSuggestions]);

  const renderAsyncContent = () => {
    if (error) return (
      <Alert variant="danger">
        <FontAwesomeIcon icon={solid('exclamation-triangle')} />
        <span className="ms-2">An error occurred during asset retrieve. Try again later.</span>
      </Alert>
    );

    if (!application) return (
      <div className="d-flex justify-content-center py-5">
        <AlidaLoader size={300} />
      </div>
    );

    return (
      <>
        <div className="d-flex align-items-center mb-3">
          <Col>
            <Breadcrumb>
              <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/bda-applications' }}>{applicationLabels.plural}</Breadcrumb.Item>
              <Breadcrumb.Item active>{application.name}</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          {!application.template && renderApplicationMedia()}
          {application!.versions && application!.versions.length > 0 && renderVersions()}
        </div>


        <Card className={classNames("item-detail-group main bg-application", { "bg-template": application.template })}>
          <FontAwesomeIcon className="item-icon" icon={solid('laptop-code')} />

          <div className="position-relative px-2 pt-2">
            <Flex justify={application.template ? "space-between" : "end"}>
              {application.template && <Badge bg="dark" className="w-auto shadow text-uppercase">Template</Badge>}
              <Badge className="w-auto shadow">{application.accessLevel}</Badge>
            </Flex>

            <div className="p-2">
              <Row className="gx-0 align-items-center justify-content-md-between">
                <Col xs={12} md="auto" className="pe-3">
                  <h3 className="mb-0">{application.name}</h3>
                  <p className="mb-4">{application.description}</p>
                </Col>

                <Col xs={12} md="auto" className="mb-2 mb-md-0 text-center text-md-start">
                  {!application.template && (
                    <>
                      {application.mlFlowUrl && (
                        <a href={application.mlFlowUrl} target="_blank" rel="noopener noreferrer" className="me-3">
                          <Tooltip title="Experiments">
                            <button className="circle-button">
                              <FontAwesomeIcon icon={solid('flask-vial')} />
                            </button>
                          </Tooltip>
                        </a>
                      )}
                      <Tooltip title={`${applicationLabels.singular} Notes`}>
                        <button className="circle-button" onClick={openApplicationNotes}>
                          <FontAwesomeIcon icon={solid("comment")} />
                        </button>
                      </Tooltip>
                      {window.__env.EXTERNAL_SERVICE_ENABLED && (
                        <Tooltip title="Show Deployment Suggestions">
                          <button className="circle-button" onClick={handleGetDeploymentSuggestions}>
                            <FontAwesomeIcon icon={solid('info-circle')} />
                          </button>
                        </Tooltip>
                      )}
                      <Tooltip title={`Manage ${projectLabels.plural}`}>
                        <button className="circle-button" onClick={openProjectsModal}>
                          <span className="fa-layers">
                            <FontAwesomeIcon icon={solid('folder')} transform="left-14 grow-2" />
                            <FontAwesomeIcon icon={solid('cog')} transform="shrink-4 down-8 right-3" />
                          </span>
                        </button>
                      </Tooltip>
                      <Tooltip title={application.status === "RUNNING" || application.status === "PARTIAL" || application.status === "STARTING" ? "Pause" : "Run"}>
                        <button className="circle-button" onClick={toggleApplication} disabled={application.status === "STARTING"}>
                          <FontAwesomeIcon icon={application.status === "RUNNING" || application.status === "PARTIAL" || application.status === "STARTING" ? solid('pause') : solid('play')} />
                        </button>
                      </Tooltip>
                      <Tooltip title="Export">
                        <button className="circle-button" onClick={onExportApplication}>
                          <FontAwesomeIcon icon={solid('share-square')} />
                        </button>
                      </Tooltip>
                      <Tooltip title={`Download ${applicationLabels.singular} Report`}>
                        <button className="circle-button" onClick={onDownloadReport}>
                          <FontAwesomeIcon icon={solid('chart-simple')} />
                        </button>
                      </Tooltip>
                    </>
                  )}
                  <Tooltip title={`${application.template ? `Create ${applicationLabels.singular}` : 'Create Template'}`} mouseEnterDelay={0.3}>
                    <button className="circle-button" onClick={application.template ? navigateToApplicationEdit(true) : createTemplateFromApplication}>
                      {application.template
                        ? <FontAwesomeIcon icon={solid('plus')} />
                        : <FontAwesomeIcon icon={solid('copy')} />
                      }
                    </button>
                  </Tooltip>
                  {showActions && (
                    <>
                      <Dropdown
                        menu={{
                          theme: 'dark',
                          items: [
                            { key: "edit", label: `Edit ${application.template ? 'Template' : applicationLabels.singular}`, onClick: navigateToApplicationEdit(false) },
                            { key: "smart-update", label: `Edit ${serviceLabels.singular} Properties`, onClick: handleOpenServicePropertiesModal },
                          ]
                        }}
                        placement="bottom"
                        trigger={['click']}
                        arrow
                      >
                        <Tooltip title="Edit">
                          <button className="circle-button">
                            <FontAwesomeIcon icon={solid('pen')} />
                          </button>
                        </Tooltip>
                      </Dropdown>
                      <Tooltip title="Delete">
                        <button className="circle-button" onClick={onDeleteApplication}>
                          <FontAwesomeIcon icon={solid('trash')} />
                        </button>
                      </Tooltip>
                    </>
                  )}
                </Col>
              </Row>
            </div>

            <Row className="gx-0 justify-content-between">
              <Col xs="auto">
                <div className="bg-highlight">
                  <UserItem className="negative" user={application.owner} organization={application.organization} />
                </div>
              </Col>

              {application.tags.length > 0 && (
                <Flex className="tags-wrapper w-auto my-2">
                  {application.tags.map(tag => <AppTag className="me-1" tag={tag} key={tag} />)}
                </Flex>
              )}
            </Row>

            <div className="item-dates mb-2">
              <div className="d-inline-block">
                <b>Created:</b>
                <span className="ms-1">{formatDate(application!.createDateTime!)}</span>
              </div>
              <div className="d-inline-block ms-2">
                <b>Last Update:</b>
                <span className="ms-1">{formatDate(application!.updateDateTime!)}</span>
              </div>
            </div>
          </div>

          {!application.template && (
            <Card.Footer className={`application-status detail-status ${application.status || 'READY'}`}>
              <span>{application.status || "READY"}</span>
            </Card.Footer>
          )}
        </Card>

        <AntCollapse className="mb-2" ghost defaultActiveKey="workflow">
          <AntCollapse.Panel
            header={
              <>
                <FontAwesomeIcon icon={solid('diagram-project')} fixedWidth />
                <span className="ms-2">Workflow</span>
              </>
            }
            key="workflow"
            className="p-0"
            showArrow={false}
            extra={
              <>
                {!application.template && (
                  <button className="add-schedule-btn" onClick={showApplicationRuns}>
                    <FontAwesomeIcon icon={solid('history')} />
                    <span className="ms-2">Executions</span>
                  </button>
                )}
              </>
            }>
            <div className="application-workflow">
              <Col className="workflow-col position-relative">
                {selectedRun && (
                  <div className="run-info">
                    <FontAwesomeIcon size="xl" icon={selectedRun.runType === "SCHEDULED" ? regular('clock') : regular('play-circle')} fixedWidth />

                    <div className="ps-2">
                      <h6 className="mb-1">Execution: {selectedRun.startDate && formatDate(selectedRun.startDate)}</h6>
                      {getStatusBadge(selectedRun.currentStatus)}
                    </div>

                    <IconButton className="ms-3" onClick={handleRunClose}>
                      <FontAwesomeIcon size="lg" icon={solid('times')} />
                    </IconButton>
                  </div>
                )}
                <DesignerComponent
                  darkBackground={selectedRun !== undefined}
                  readOnly={true}
                  onElementSelected={handleElementDetail}
                  initialNodes={initialGraph?.nodes}
                  initialEdges={initialGraph?.edges}
                />
              </Col>

              <Col className={classNames('service-col', { open: showElementDetail })}>
                {service && renderServiceDetail()}
                {dataset && renderDatasetDetail()}
                {model && renderModelDetail()}
                {runs && renderApplicationRuns()}
              </Col>
            </div>
          </AntCollapse.Panel>
        </AntCollapse>

        {renderApplicationGroups()}
      </>
    );
  }

  return (
    <Container className="mt-3 application-detail">
      <Helmet>
        <title>{applicationLabels.singular} {id} Detail</title>
      </Helmet>

      {renderAsyncContent()}

      <br />

      <Modal show={showDeleteModal} onHide={handleDeleteClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete {applicationLabels.singular}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete {applicationLabels.singular} <b>{application && application.name}</b>?</p>

          <Alert className="p-2" variant="warning">
            <FontAwesomeIcon icon={solid('exclamation-triangle')} />
            <span className="ms-2">Remember, this operation cannot be undone.</span>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" size="sm" className="border" onClick={handleDeleteClose}>Close</Button>
          <Button variant="danger" size="sm" onClick={deleteApplication}>Delete</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeploymentSuggestionsModal} onHide={handleDeploymentSuggestionsModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Deployment Suggestions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {renderDeploymentSuggestions()}
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" variant="light" size="sm" className="border" onClick={handleDeploymentSuggestionsModalClose}>Close</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEditServicePropertiesModal} onHide={handleCloseServicePropertiesModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit {serviceLabels.singular} Properties</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert className="p-2 mb-3 font-smaller" variant="primary">
            <Flex align="center">
              <FontAwesomeIcon icon={solid('info-circle')} />
              <Col className="px-3">Write the JSON spec to including the properties you want to change the value of.</Col>
              <AntButton type="text" className="text-primary" onClick={toggleSmartEditExample} size="small">{showSmartUpdateExample ? 'Hide' : 'Show'} Value</AntButton>
            </Flex>
            <Collapse in={showSmartUpdateExample}>
              <div>
                <Flex align="center" className="smart-update-example-container p-2 mt-2">
                  <pre className="m-0 font-monospace font-sm">{JSON.stringify(SMART_UPDATE_EXAMPLE_PAYLOAD, null, 4)}</pre>
                  <IconButton tooltip="Copy to Clipboard" className="p-1" onClick={copyToClipboard}>
                    <FontAwesomeIcon icon={solid('clipboard')} size="lg" />
                  </IconButton>
                </Flex>
              </div>
            </Collapse>
          </Alert>

          <ScriptEditor
            value={serviceProperties}
            onChange={setServiceProperties}
            onValidated={handleErrors}
            height={300}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" size="sm" className="border" onClick={handleCloseServicePropertiesModal}>Close</Button>
          <Button disabled={invalidProperties} variant="success" size="sm" onClick={handleEditServicePropertiesSubmit}>Save</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showNotesModal} size="lg" onHide={handleCloseApplicationNotes}>
        <Modal.Header closeButton>
          <Modal.Title className="text-capitalize">{applicationLabels.singular || ""} Notes</Modal.Title>
        </Modal.Header>
        <AnnotationsForm notes={application?.notes} onCancel={handleCloseApplicationNotes} readOnly />
      </Modal>

      <Modal show={showDocumentationModal} size="lg" onHide={handleDocumentationModalClose}>
        <Modal.Header closeButton>
          <Modal.Title className="text-capitalize">{service?.name} Documentation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {markdownError
            ? (
              <Alert variant="danger">
                <FontAwesomeIcon icon={solid('exclamation-circle')} />
                <span className="ms-2">An error occurred, please try again later.</span>
              </Alert>
            )
            : serviceMarkdown
              ? (
                <div data-color-mode="light">
                  <MDEditor.Markdown source={serviceMarkdown} />
                </div>
              )
              : <AppLoader justify="center" size={80} />
          }
        </Modal.Body>
      </Modal>

      <Modal show={showServiceNotesModal} size="lg" onHide={handleCloseServiceNotes}>
        <Modal.Header closeButton>
          <Modal.Title className="text-capitalize">{serviceLabels.singular || ""} Notes</Modal.Title>
        </Modal.Header>
        <AnnotationsForm notes={service?.notes} onCancel={handleCloseServiceNotes} readOnly />
      </Modal>

      <Modal show={showDeleteScheduleModal} onHide={handleDeleteClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete {applicationLabels.singular} Schedule</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete schedule <b>{schedule && schedule.name}</b>?</p>

          <Alert className="p-2" variant="warning">
            <FontAwesomeIcon icon={solid('exclamation-triangle')} />
            <span className="ms-2">Remember, this operation cannot be undone.</span>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" size="sm" className="border" onClick={handleDeleteClose}>Close</Button>
          <Button variant="danger" size="sm" onClick={deleteSchedule}>Delete</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showScheduleModal} onHide={handleScheduleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{newSchedule?.id ? "Edit" : "Create"} {applicationLabels.singular} Schedule</Modal.Title>
        </Modal.Header>
        {newSchedule && (
          <Form noValidate validated={validated} onSubmit={handleScheduleSubmit}>
            <Modal.Body>
              <Form.Group controlId="schedule-name" className="mb-3">
                <Form.Label>Schedule Name</Form.Label>
                <Form.Control size="sm" placeholder="Schedule name" value={newSchedule.name} onChange={handleScheduleFieldChange('name')} required />
                <Form.Control.Feedback type="invalid">Schedule Name is required.</Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="schedule-cron-exepression" className="mb-3">
                <Form.Label className="mb-2">Cron Expression</Form.Label>
                <Cron value={newSchedule.cronExpression} clearButtonAction="empty" clearButtonProps={{ className: "bg-primary" }} setValue={handleScheduleFieldChange('cronExpression', true)} onError={handleCronError} />
                <h6 className="text-center text-muted">OR</h6>
                <Form.Control size="sm" value={customCron} onChange={handleCustomCronChange} onBlur={updateScheduleCron} placeholder="Manual cron expression" />
                {cronError && <Form.Control.Feedback type="invalid" className="d-block">{cronError}</Form.Control.Feedback>}
                <Form.Text>You can insert cron expression manually in the field above. To know more about the specs, please refer to <a href="https://crontab.guru/" target="_blank" rel="noopener noreferrer">crontab quick reference</a>.</Form.Text>
              </Form.Group>

            </Modal.Body>
            <Modal.Footer>
              <Button variant="light" size="sm" type="button" className="border" onClick={handleScheduleClose}>Close</Button>
              <Button variant="success" size="sm" type="submit">Confirm</Button>
            </Modal.Footer>
          </Form>
        )}
      </Modal>

      <Modal show={showExportModal} onHide={handleExportClose}>
        <Modal.Header closeButton>
          <Modal.Title>Export {applicationLabels.singular}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="export-mode" as={Row} className="gx-0 align-items-center">
            <Col md={6} lg={4}>
              <Form.Label>Export Mode</Form.Label>
            </Col>
            <Col md={6} lg={8}>
              <Form.Select size="sm" value={exportMode} onChange={handleExportModeChange}>
                <option value="cluster">Cluster</option>
                {/* <option value="standalone">Standalone</option> */}
                <option value="clone">Clone</option>
                <option value="manifest">Manifest</option>
              </Form.Select>
            </Col>
          </Form.Group>

          {/* TODO FIX/REMOVE THIS */}
          {/* {exportMode === 'standalone' && (
            <>
              {application?.workflows[0].mode === "STREAM" && <Form.Check id="enable-kafka" type="checkbox" onChange={handleExportOptionsChange('kafka')} className="mb-2 mt-3" label="Enable Kafka" />}
              <Form.Check id="export-rar" type="checkbox" onChange={handleExportOptionsChange('rar')} disabled label="Export .rar" />
            </>
          )} */}
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button variant="light" size="sm" className="border" onClick={handleExportClose}>Close</Button>
          <Button variant="success" size="sm" onClick={exportApplication}>
            <FontAwesomeIcon icon={solid('share-square')} />
            <span className="ms-2">Export</span>
          </Button>
        </Modal.Footer>
      </Modal>

      <EntityDefinitionModal open={showCloneModal} onClose={handleCloneModalClose} entity={applicationClone} label={applicationLabels.singular} />

      <Modal size="lg" show={showEnvVarsModal} onHide={handleEnvVarsModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{environmentVariablesLabels.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{renderEnvVarModal()}</Modal.Body>
      </Modal>

      <Modal show={showRunModal} onHide={handleRunModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Select Namespace</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="namespace" as={Row} className="gx-0 align-items-center">
            <Col md={6} lg={4}>
              <Form.Label>Namespace</Form.Label>
            </Col>
            <Col md={6} lg={8}>
              <Select
                className="w-100"
                placeholder="Namespace"
                value={selectedNamespace}
                onSelect={setSelectedNamespace}
                options={(applicationNamespaces || []).map(n => ({ label: n, value: n }))}
              />
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button variant="light" size="sm" className="border" onClick={handleRunModalClose}>Close</Button>
          <Button variant="success" size="sm" onClick={runApplication}>
            <FontAwesomeIcon icon={solid('play')} />
            <span className="ms-2">Run</span>
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showAssetsModal} onHide={handleAssetsModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{serviceLabels.singular} '{service?.name}' Assets</Modal.Title>
        </Modal.Header>
        <Modal.Body>{service && renderServiceAssets()}</Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="light" className="border text-primary d-flex" size="sm" disabled={!selectedAsset} onClick={handleDownloadAsset}>
            <FontAwesomeIcon icon={solid('download')} />
            <span className="ms-2">Download Asset</span>
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal size="lg" show={showPreviewModal} onHide={handlePreviewModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{previewDataset?.name} Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {renderDatasetPreview()}
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="light" size="sm" className="border" onClick={handlePreviewModalClose}>Close</Button>
        </Modal.Footer>
      </Modal>


      <Modal size="lg" show={showLogsModal} onHide={handleLogsModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{service?.name} Logs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {renderServiceLogs()}
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          {logs && (
            <Button variant="light" className="border text-primary" size="sm" onClick={downloadLogs}>
              <FontAwesomeIcon icon={solid('download')} />
              <span className="ms-2">Download Log File</span>
            </Button>
          )}
          <Button variant="light" size="sm" className={classNames("border", { "ms-2": logs })} onClick={handleLogsModalClose}>Close</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showProjectsModal} onHide={handleProjectsModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{applicationLabels.singular} Projects</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AssetProjectsEditor assetId={+id!} assetType="application" assetLabel={applicationLabels.singular} />
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="light" className="border" onClick={handleProjectsModalClose} size="sm">Cancel</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default function withProvider() {
  return (
    <ReactFlowProvider>
      <BdaApplicationDetail />
    </ReactFlowProvider>
  )
}